import { ISelectedPlan } from 'contexts/SelectedPlans';
import { IMember } from 'types';

function checkIsValidObjectAndProprty(object: any, property: string) {
  if (typeof object !== 'object' || object === null || typeof object === 'undefined') {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(object, property);
}

function checkIfIsValidResponse(response: any) {
  if (checkIsValidObjectAndProprty(response, 'Error Code') && checkIsValidObjectAndProprty(response, 'Error Message')) {
    return response['Error Code'] === '00' && response['Error Message'] === 'Success';
  }

  return false;
}

function checkIfNeedConfirmUpdate({ member, selectedPlans }: { member: IMember; selectedPlans: ISelectedPlan[] }) {
  if (typeof member?.currentPlan?.miles === 'undefined') return false;

  let needConfirm = true;
  selectedPlans.forEach((plan: ISelectedPlan) => {
    if (plan.miles === member?.currentPlan?.miles) {
      needConfirm = false;
    }
  });

  return needConfirm;
}

const defaultModalPropsDefaults = {
  imageClass: 'vbz-icon-corporates-club-baggage',
  component: 'defaultModalError',
  isOpen: false,
  onClick: () => null,
  secondClick: () => null,
};

const renderPlans = (index: number, totalPlans: number, content: string) => {
  return index === 0
    ? totalPlans === 1
      ? content
      : totalPlans === 2
      ? `${content} e`
      : `${content},`
    : index === totalPlans - 2
    ? `${content} e`
    : index === totalPlans - 1
    ? content
    : `${content},`;
};

interface openModalErrorProps {
  setDefaultModalProps: (value: any) => void;
  component?: string;
  secondClick: () => void;
}

const openModalError = ({
  setDefaultModalProps,
  component = 'defaultModalError',
  secondClick,
}: openModalErrorProps) => {
  setDefaultModalProps(() => ({
    ...defaultModalPropsDefaults,
    component,
    isOpen: true,
    onClick: () => setDefaultModalProps((prevState: any) => ({ ...prevState, isOpen: false })),
    secondClick,
  }));
};

export {
  checkIfIsValidResponse,
  checkIfNeedConfirmUpdate,
  checkIsValidObjectAndProprty,
  defaultModalPropsDefaults,
  renderPlans,
  openModalError,
};
